import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';

export const useRemoveApprovedTimestampAndReminderHook = (): {
    removeApprovedTimestampAndReminder: () => Promise<void>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const removeApprovedTimestampAndReminder = async (): Promise<void> => {
        await OnlineSales.removeApprovedTimestampAndReminder(jobNumber, sessionId);
    };

    return { removeApprovedTimestampAndReminder };
};
